var $28feffc3d61a8691$exports = {};
$28feffc3d61a8691$exports = {
    "close": `Zav\u{159}\xedt`,
    "notifications": `Upozorn\u{11B}n\xed`
};


export {$28feffc3d61a8691$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
